<template>
  <v-list-item class="px-0">
    <v-list-item-avatar :size="avatarSize">
      <slot name="avatar">
        <AvatarContent :object="value" />
      </slot>
    </v-list-item-avatar>
    <v-list-item-content>
      <slot>
        {{ defaultContent }}
      </slot>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import AvatarContent from '../AvatarContent.vue';

export default {
  components: { AvatarContent },
  props: {
    value: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'sm',
      validator: v => ['sm', 'md', 'lg', 'xl'].includes(v),
    },
  },
  computed: {
    defaultContent() {
      if (!this.value) return '';
      return this.value?.name || this.value?.code;
    },
    avatarSize() {
      switch (this.size) {
        case 'sm':
          return 40;
        case 'md':
          return 52;
        case 'lg':
          return 64;
        default:
          return 72;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
